import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup'

import DropDown from '../../../../components/Input/DropDown'
import LanguageSelect from '../../../../components/Shared/LanguageSelect'
import ErrorMessageWithExclamation from '../../../../components/UI/ErrorMessageWithExclamation'
import { Button } from '../../../../components/UI'

import {
  selectIsLoading,
  selectUserData,
} from '../../../../routing/fetchingfunction/user/user.reducer'
import { setStep, updateAbout } from '../../../../routing/fetchingfunction/user/user.action'

import { LanguageScheme } from '../../../../routing/utils/validators'

import { interfaceLanguages } from '../../../../constants'

const Languages = () => {
  const dispatch = useDispatch()

  const userData = useSelector(selectUserData)
  const isLoading = useSelector(selectIsLoading)

  const userLanguages = userData?.profile?.user_profile_languages || []

  const {
    formState: { errors },
    handleSubmit,
    control,
    clearErrors,
    setError,
    setValue,
  } = useForm({
    defaultValues: {
      interface_language: interfaceLanguages[0].value,
      newLanguage: '',
      newLevel: '',
      user_profile_languages: userLanguages,
    },
    resolver: yupResolver(LanguageScheme),
  })

  useEffect(() => {
    clearErrors('user_profile_languages')

    setValue('user_profile_languages', userLanguages)
  }, [userData])

  const handleFormSubmit = (data) => {
    dispatch(
      updateAbout({
        id: userData.id || userData.pk,
        profile: {
          ...userData.profile,
          user_profile_languages: data.user_profile_languages,
        },
      })
    )
    // .then((data) => {
    //   if (!data.error) {
    //     console.log(data, 'no error ********************')
    //     dispatch(setStep(1))
    //   }
    // })
  }

  return (
    <div className="w-full pb-16">
      <h3 className="text-2xl font-bold rounded-lg bg-[#FEEBDD] p-[20px] text-primary-100">
        Language Settings
      </h3>

      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="mt-[20px] bg-[#FEEBDD] rounded-[10px] p-[32px]"
      >
        <div className="w-full flex items-start flex-col">
          <span className="text-sm font-semibold text-primary-100">Interface Language</span>

          <div className="mt-2 w-1/2">
            <Controller
              control={control}
              name="interface_language"
              render={({ field: { value, onChange } }) => {
                return (
                  <DropDown
                    menuItems={interfaceLanguages}
                    placeholder="Select Language"
                    value={value}
                    setValue={onChange}
                  />
                )
              }}
            />
          </div>
        </div>

        <div className="mt-[20px] w-4/5 h-screen">
          <span className="text-sm font-semibold text-primary-100">Language Settings</span>

          <Controller
            control={control}
            name="user_profile_languages"
            render={({ field: { value, onChange } }) => {
              return (
                <LanguageSelect
                  value={value}
                  clearErrors={clearErrors}
                  setError={setError}
                  onChange={onChange}
                />
              )
            }}
          />

          <div className="w-full flex flex-col">
            {errors.user_profile_languages && (
              <ErrorMessageWithExclamation text={errors.user_profile_languages.message} />
            )}

            <Button
              type="submit"
              className="mt-[20px] w-fit !text-sm !font-semibold min-w-[129px]"
              isLoading={isLoading}
            >
              Save Changes
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default Languages
